import { FileTile, FileTileThumbnail, ResponsiveImage, FileTileDeleteButton, FlexBox, Box } from '@vp/swan';
import React from 'react';
import { IMessagePayload } from '../../interfaces/component-interfaces';

export interface IUploadAttachmentsPreviewProps {
  selectedFilePayload: IMessagePayload[];
  isLoading: boolean;
  handleDeletePreview: (fileName: string) => void;
}

const UploadAttachmentsPreview: React.FC<IUploadAttachmentsPreviewProps> = ({ selectedFilePayload, isLoading, handleDeletePreview }) => {
  return (
    <FlexBox gap="4" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
      {selectedFilePayload &&
        selectedFilePayload.length > 0 &&
        selectedFilePayload.map((file) => {
          return (
            <Box key={file.fileData.name}>
              <FileTile
                key={file.fileData.name}
                fileName={`${isLoading ? 'uploading...' : file.fileData.name}`}
                accessibleTextForProgress="100% loaded"
                accessibleTextForSpinner="Waiting"
                skin={`${isLoading ? 'queued' : 'standard'}`}
                style={{ maxWidth: '78px', maxHeight: '78px' }}
              >
                <FileTileThumbnail>
                  <ResponsiveImage src={file.previewUrl} alt={``} />
                </FileTileThumbnail>
                <FileTileDeleteButton accessibleText="Delete file: my-file.png" onClick={() => handleDeletePreview(file.fileData.name)} />
              </FileTile>
            </Box>
          );
        })}
    </FlexBox>
  );
};

export default UploadAttachmentsPreview;
